module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('vuetable', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "tableData": _vm.tableData,
      "tableTitle": 'Exchange Rate Histories',
      "fields": _vm.fields,
      "maxItems": _vm.maxValue
    },
    on: {
      "pages-remaining": _vm.loadMore
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87851782"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/ExchangeRateHistory/ExchangeRateHistorySearchResults.vue
// module id = 2248
// module chunks = 1